import messages from "../../../locale/messages";
import {
  inputTextLimit,
  inputDescLimit,
  containsMalicious,
} from "../../../helpers/textRestriction";

const validate = (values, props) => {
  // Add props parameter
  const errors = {};

  if (!values.itemName) {
    errors.itemName = messages.Required;
  } else if (values.itemName && values.itemName.trim() == "") {
    errors.itemName = messages.blankSpace;
  } else if (values.itemName && values.itemName.length > inputTextLimit) {
    errors.itemName = messages.inputFieldRestriction;
  } else if (containsMalicious(values.itemName)) {
    errors.itemName = messages.invalidInput;
  }

  if (!values.otherItemName) {
    errors.otherItemName = messages.Required;
  } else if (values.otherItemName && values.otherItemName.trim() == "") {
    errors.otherItemName = messages.blankSpace;
  } else if (
    values.otherItemName &&
    values.otherItemName.length > inputTextLimit
  ) {
    errors.otherItemName = messages.inputFieldRestriction;
  } else if (containsMalicious(values.otherItemName)) {
    errors.otherItemName = messages.invalidInput;
  }

  if (!values.startValue) {
    errors.startValue = messages.Required;
  } else if (
    values.startValue &&
    (Number(values.startValue) <= 0 ||
      Number(values.startValue) != parseInt(values.startValue, 10))
  ) {
    errors.startValue = messages.startValueIsInvalid;
  } else if (values.startValue) {
    // Add validation based on typeId
    const startValue = Number(values.startValue);
    if (values.typeId === 18 && startValue > 30) {
      errors.startValue = messages.maxValue30;
    } else if (values.typeId === 19 && startValue > 365) {
      errors.startValue = messages.maxValue365;
    }
  }

  if (!values.endValue) {
    errors.endValue = messages.Required;
  } else if (
    values.endValue &&
    (Number(values.endValue) <= 0 ||
      Number(values.endValue) != parseInt(values.endValue, 10))
  ) {
    errors.endValue = messages.endValueIsInvalid;
  } else if (values.endValue) {
    // Add validation based on typeId
    const endValue = Number(values.endValue);
    if (values.typeId === 18 && endValue > 30) {
      errors.endValue = messages.maxValue30;
    } else if (values.typeId === 19 && endValue > 365) {
      errors.endValue = messages.maxValue365;
    }
  }

  if (Number(values.endValue) < Number(values.startValue)) {
    errors.endValue = messages.endValueGreater;
  }

  if (values.itemDescription && values.itemDescription.trim() == "") {
    errors.itemDescription = messages.blankSpace;
  } else if (
    values.itemDescription &&
    values.itemDescription.length > inputDescLimit
  ) {
    errors.itemDescription = messages.descriptionFieldRestriction;
  } else if (containsMalicious(values.itemDescription)) {
    errors.itemDescription = messages.invalidInput;
  }

  return errors;
};

export default validate;
